import { render } from "./QClosing.vue?vue&type=template&id=36b8952e&ts=true"
import script from "./QClosing.vue?vue&type=script&lang=ts"
export * from "./QClosing.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__